import { Component } from '@angular/core';
import { DeduplikacijaAttributeStateService } from '@app/shared/services/agent-selection-provider.service';
import { CommonFormComponent, DynamicFormService } from '@ntap/common';
import { AttributeStateService } from '@ntap/core';

@Component({
  selector: 'app-deduplikacija-agent-dropdown',
  template:
    '<ntap-prime-inputdropdown [inputParam]="inputParam"></ntap-prime-inputdropdown>',
  providers: [
    {
      provide: AttributeStateService,
      useExisting: DeduplikacijaAttributeStateService
    }
  ]
})
export class DeduplikacijaAgentDropdownComponent extends CommonFormComponent {
  constructor(
    protected override formService: DynamicFormService,
    attributeStateService: DeduplikacijaAttributeStateService
  ) {
    super(formService, attributeStateService);
    this.log('dropdown constructor');
  }
}
